<form role="form" [formGroup]="form" novalidate>
  <div class="box-body">
    <mat-stepper linear #stepper (selectionChange)="onStepChange($event.selectedIndex)">
      <mat-step label="Details" [completed]="canEnterSecondStep()">
        <div class="form-group col-sm-6 col-xs-12">
          <label for="code">Parking Code*</label>
          <input type="text" class="form-control" formControlName="code" placeholder="Enter Parking Code">
          <control-message
            *ngIf="form.controls['code'].hasError('required') && (secondStepAttempt || form.controls['code'].touched)"
            message="Parking code is required."></control-message>
        </div>
        <div class="form-group col-sm-6 col-xs-12">
          <label for="title">Name of parking place*</label>
          <input type="text" class="form-control" formControlName="title" placeholder="Enter the name">
          <control-message
            *ngIf="form.controls['title'].hasError('required') && (secondStepAttempt || form.controls['title'].touched)"
            message="Parking name is required."></control-message>
        </div>
        <div class="form-group col-sm-6 col-xs-12">
          <label for="title">Arabic Name of parking place*</label>
          <input type="text" class="form-control" formControlName="title_ar" placeholder="Enter the arabic name">

          <control-message
            *ngIf="form.controls['title_ar'].hasError('required') && (secondStepAttempt || form.controls['title_ar'].touched)"
            message="Parking arabic name is required."></control-message>
        </div>

        <div class="form-group col-sm-6 col-xs-12">
          <label for="capacity">Capacity*</label>
          <input type="number" class="form-control" formControlName="capacity" placeholder="Capacity">
          <control-message
            *ngIf="form.controls['capacity'].hasError('required') && (secondStepAttempt || form.controls['capacity'].touched)"
            message="Capacity is required."></control-message>
          <control-message
            *ngIf="form.controls['capacity'].hasError('pattern') && (secondStepAttempt || form.controls['capacity'].touched)"
            message="Capacity must be a number."></control-message>
        </div>

        <div class="form-group col-sm-6 col-xs-12">
          <label for="min_wallet_limit">Minimum wallet limit*</label>
          <input type="number" class="form-control" formControlName="min_wallet_limit" placeholder="Minimum limit">
          <control-message
            *ngIf="form.controls['min_wallet_limit'].hasError('required') && (secondStepAttempt || form.controls['min_wallet_limit'].touched)"
            message="Minimum limit is required."></control-message>
          <control-message
            *ngIf="form.controls['min_wallet_limit'].hasError('pattern') && (secondStepAttempt || form.controls['min_wallet_limit'].touched)"
            message="Minimum limit must be a number."></control-message>
        </div>

        <div class="form-group col-sm-6 col-xs-12">
          <label>Vigilante API Url*</label>
          <input type="text" class="form-control" formControlName="vg_url" placeholder="Vigilante API Url">
          <control-message
            *ngIf="form.controls['vg_url'].hasError('required') && (secondStepAttempt || form.controls['vg_url'].touched)"
            message="Vigilante API Url is required."></control-message>
          <control-message
            *ngIf="form.controls['vg_url'].hasError('url') && (secondStepAttempt || form.controls['vg_url'].touched)"
            message="Vigilante API Url must be valid."></control-message>
        </div>

        <div class="form-group col-sm-6 col-xs-12">
          <label>Vigilante admin*</label>
          <input type="text" class="form-control" formControlName="vg_admin" placeholder="Vigilante admin">
          <control-message
            *ngIf="form.controls['vg_admin'].hasError('required') && (secondStepAttempt || form.controls['vg_admin'].touched)"
            message="Vigilante admin is required."></control-message>
        </div>

        <div class="form-group col-sm-6 col-xs-12">
          <label>Vigilante password*</label>
          <input type="text" class="form-control" formControlName="vg_password" placeholder="Vigilante password">
          <control-message
            *ngIf="form.controls['vg_password'].hasError('required') && (secondStepAttempt || form.controls['vg_password'].touched)"
            message="Vigilante password is required."></control-message>
        </div>

        <div class="form-group col-sm-6 col-xs-12">
          <label>Guest Online Payment Link</label>
          <input type="text" class="form-control" formControlName="online_payment_link"
            placeholder="Guest Online Payment Link">
          <control-message
            *ngIf="form.controls['online_payment_link'].hasError('required') && (secondStepAttempt || form.controls['online_payment_link'].touched)"
            message="Online Payment Link is required."></control-message>
          <control-message
            *ngIf="form.controls['online_payment_link'].hasError('url') && (secondStepAttempt || form.controls['online_payment_link'].touched)"
            message="Online Payment Link must be valid."></control-message>
        </div>


        <div class="form-group col-sm-6 col-xs-12">
          <label for="online_payment_grace_period">Online Payment Grace Period(in mins)</label>
          <input type="number" class="form-control" formControlName="online_payment_grace_period"
            placeholder="Grace Period(in mins)">
          <control-message
            *ngIf="form.controls['online_payment_grace_period'].hasError('required') && (secondStepAttempt || form.controls['vat_rate'].touched)"
            message="Grace Period is required."></control-message>
          <control-message
            *ngIf="form.controls['online_payment_grace_period'].hasError('pattern') && (secondStepAttempt || form.controls['online_payment_grace_period'].touched)"
            message="Grace Period must be a number."></control-message>
        </div>


        <div class="form-group col-sm-6 col-xs-12">
          <label for="parking_charge_type">Charge Type*</label>
          <select class="form-control" formControlName="parking_charge_type">
            <option value="">select a charge type</option>
            <option *ngFor="let item of parking_charge_types" value="{{item.key}}">{{item.value}}</option>
          </select>
          <control-message
            *ngIf="form.controls['parking_charge_type'].hasError('required') && (secondStepAttempt || form.controls['parking_charge_type'].touched)"
            message="Charge type is required."></control-message>
        </div>

        <div class="form-group col-sm-6 col-xs-12">
          <label for="currency">Currency*</label>
          <select class="form-control" formControlName="currency">
            <option value="">select a currency</option>
            <option *ngFor="let item of currency_choices" value="{{item.key}}">{{item.value}}</option>
          </select>
          <control-message
            *ngIf="form.controls['currency'].hasError('required') && (secondStepAttempt || form.controls['currency'].touched)"
            message="Currency is required."></control-message>
        </div>

        <div class="form-group col-sm-6 col-xs-12">
          <label for="vat_rate">Vat Rate*</label>
          <input type="number" class="form-control" formControlName="vat_rate" placeholder="Vat Rate">
          <control-message
            *ngIf="form.controls['vat_rate'].hasError('required') && (secondStepAttempt || form.controls['vat_rate'].touched)"
            message="Vat Rate is required."></control-message>
          <control-message
            *ngIf="form.controls['vat_rate'].hasError('pattern') && (secondStepAttempt || form.controls['vat_rate'].touched)"
            message="Vat Rate must be a number."></control-message>
        </div>



        <div class="form-group col-sm-6 col-xs-12">
          <label for="capacity">Charge per hour*</label>
          <input type="number" class="form-control" formControlName="perhour" placeholder="Per hour">
          <control-message
            *ngIf="form.controls['perhour'].hasError('required') && (secondStepAttempt || form.controls['perhour'].touched)"
            message="Per hour is required."></control-message>
          <control-message
            *ngIf="form.controls['perhour'].hasError('pattern') && (secondStepAttempt || form.controls['perhour'].touched)"
            message="Per hour must be a number."></control-message>
        </div>

        <div class="form-group col-sm-6 col-xs-12">
          <label for="capacity">Processing fee*</label>
          <input type="number" class="form-control" formControlName="processing_fee" placeholder="Processing fee">
          <control-message
            *ngIf="form.controls['processing_fee'].hasError('required') && (secondStepAttempt || form.controls['processing_fee'].touched)"
            message="Processing fee is required."></control-message>
          <control-message
            *ngIf="form.controls['processing_fee'].hasError('pattern') && (secondStepAttempt || form.controls['processing_fee'].touched)"
            message="Processing fee must be a number."></control-message>
        </div>

        <div class="form-group col-sm-6 col-xs-12">
          <label for="parking_place_type_id">Parking Type*</label>
          <select class="form-control" formControlName="parking_place_type_id">
            <option value="">select a parking type</option>
            <option *ngFor="let item of parking_types" value="{{item.id}}">{{item.label}}</option>
          </select>
          <control-message
            *ngIf="form.controls['parking_place_type_id'].hasError('required') && (secondStepAttempt || form.controls['parking_charge_type'].touched)"
            message="Parking type is required."></control-message>
        </div>

        <div class="form-group col-sm-6 col-xs-12">
          <label>Logo*</label>
          <input type="file" class="form-control" #logo (change)="onFileChange($event)">
          <control-message
            *ngIf="form.controls['base64'].hasError('required') && (secondStepAttempt || form.controls['base64'].touched)"
            message="Logo is required."></control-message>
        </div>

        <div class="form-group col-sm-6 col-xs-12">
          <label>Upload Video*</label>
          <input type="file" class="form-control" #video (change)="onVideoChange($event)">
          <control-message
            *ngIf="form.controls['base64'].hasError('required') && (secondStepAttempt || form.controls['base64'].touched)"
            message="Logo is required."></control-message>
        </div>

        <div class="box-footer col-12">
          <button type="button" class="btn btn-success pull-right"
            (click)="canEnterSecondStep() ? stepper.next() : secondStepEnterAttempt()">
            Next step
          </button>
        </div>

      </mat-step>

      <mat-step label="Location" [completed]="canEnterThirdStep()">
        <div class="col-sm-12 col-xs-12">
          <div class="col-sm-6 col-xs-12">
            <div class="form-group col-sm-6 col-xs-12">
              <label>Area*</label>
              <input type="text" class="form-control" #search [formControl]="searchControl" formControlName="area"
                placeholder="Area">
              <control-message
                *ngIf="form.controls['area'].hasError('required') && (thirdStepAttempt || form.controls['area'].touched)"
                message="Area is required."></control-message>
            </div>
            <div class="form-group col-sm-6 col-xs-12">
              <label>Arabic Area*</label>
              <input type="text" class="form-control" #search [formControl]="searchControl" formControlName="area_ar"
                placeholder="Arabic_Area">
              <control-message
                *ngIf="form.controls['area_ar'].hasError('required') && (thirdStepAttempt || form.controls['area_ar'].touched)"
                message="Arabic Area is required."></control-message>
            </div>
            <div class="form-group col-sm-6 col-xs-12">
              <label for="city">City</label>
              <input type="text" class="form-control" formControlName="city" placeholder="City">
              <!-- <control-message *ngIf="form.controls['city'].hasError('required') && (isSubmitted || form.controls['city'].touched)" message="City is required."></control-message> -->
            </div>
            <div class="form-group col-sm-6 col-xs-12">
              <label for="city_ar">Arabic City</label>
              <input type="text" class="form-control" formControlName="city_ar" placeholder="Arabic City">
            </div>
            <!-- <div class="form-group col-sm-6 col-xs-12">
                      <label for="country">Country</label>
                      <select class="form-control" [(ngModel)]="form.country" name="country">
                        <option value="">select country</option>
                        <option *ngFor="let item of countries" value="item.code">{{item.name}}</option>
                      </select>
                    </div> -->
            <div class="form-group col-sm-6 col-xs-12">
              <label for="country">Country*</label>
              <input type="text" class="form-control" formControlName="country" placeholder="Country">
              <control-message
                *ngIf="form.controls['country'].hasError('required') && (thirdStepAttempt || form.controls['country'].touched)"
                message="Country is required."></control-message>
            </div>
            <div class="form-group col-sm-6 col-xs-12">
              <label for="country_ar">Arabic Country*</label>
              <input type="text" class="form-control" formControlName="country_ar" placeholder="Arabic Country">
              <control-message
                *ngIf="form.controls['country'].hasError('required') && (thirdStepAttempt || form.controls['country_ar'].touched)"
                message="Arabic Country is required."></control-message>
            </div>
            <div class="form-group col-sm-6 col-xs-12">
              <label for="country">Latitude*</label>
              <input type="text" class="form-control" formControlName="lat" placeholder="Latitude">
              <control-message
                *ngIf="form.controls['lat'].hasError('required') && (thirdStepAttempt || form.controls['lat'].touched)"
                message="Latitude is required."></control-message>
            </div>
            <div class="form-group col-sm-6 col-xs-12">
              <label for="longitude">Longitude*</label>
              <input type="text" class="form-control" formControlName="lng" placeholder="Longitude">
              <control-message
                *ngIf="form.controls['lng'].hasError('required') && (thirdStepAttempt || form.controls['lng'].touched)"
                message="Longitude is required."></control-message>
            </div>

            <div class="form-group col-sm-6 col-xs-12">
              <label for="area_app_label">Area App Label*</label>
              <input type="text" class="form-control" formControlName="area_app_label" placeholder="Area App Label">
              <control-message
                *ngIf="form.controls['area_app_label'].hasError('required') && (thirdStepAttempt || form.controls['area_app_label'].touched)"
                message="Area App Label is required."></control-message>
            </div>
            <div class="form-group col-sm-6 col-xs-12">
              <label for="area_app_label_ar">Arabic Area App Label*</label>
              <input type="text" class="form-control" formControlName="area_app_label_ar"
                placeholder="Arabic Area App Label">
              <control-message
                *ngIf="form.controls['area_app_label_ar'].hasError('required') && (thirdStepAttempt || form.controls['area_app_label_ar'].touched)"
                message="Area App Label is required."></control-message>
            </div>


          </div>
          <div class="col-sm-6 col-xs-12">
            <google-map #map height="400px" width="100%" [center]="{ lat: lat, lng: lng }" [zoom]="zoom"
              (mapClick)="refreshMap()">

              <map-marker [position]="{ lat: lat, lng: lng }" [options]="markerOptions"
                (mapDragend)="markerDragEndAddress($event)">
              </map-marker>

            </google-map>
          </div>
        </div>

        <div class="clearfix"></div>


        <div class="box-footer">
          <button type="button" class="btn btn-success pull-left" matStepperPrevious>
            Previous step
          </button>
          <button type="button" class="btn btn-success pull-right"
            (click)="canEnterThirdStep() ? stepper.next() : thirdStepEnterAttempt()">
            Next step
          </button>
        </div>
      </mat-step>

      <mat-step label="Payment details">
        <div formArrayName="charge_stack">
          <div class="col-sm-12 col-xs-12 form-array" [formGroup]="stack">
            <mat-card>
              <mat-card-header>
                <mat-card-title>
                  <h3 class="md-headline">Charging Stack*</h3>
                </mat-card-title>
              </mat-card-header>
              <mat-card-content>

                <div class="col-sm-12 col-xs-12">
                  <div class="form-group col-sm-2 col-xs-12">
                    <label for="from_min">From Minutes</label>
                    <input type="number" class="form-control" formControlName="from_min">
                    <control-message
                      *ngIf="stack.controls['from_min'].hasError('required') && (stack.controls['from_min'].touched)"
                      message="From minutes is required."></control-message>
                    <control-message
                      *ngIf="stack.controls['from_min'].hasError('pattern') && (stack.controls['from_min'].touched)"
                      message="From minutes must be a number."></control-message>
                  </div>
                  <div class="form-group col-sm-2 col-xs-12">
                    <label for="to_min">To Minutes</label>
                    <input type="number" class="form-control" formControlName="to_min">
                    <control-message
                      *ngIf="stack.controls['to_min'].hasError('required') && (stack.controls['to_min'].touched)"
                      message="To minutes is required."></control-message>
                    <control-message
                      *ngIf="stack.controls['to_min'].hasError('pattern') && (stack.controls['to_min'].touched)"
                      message="To minutes must be a number."></control-message>
                    <control-message
                      *ngIf="((stack.controls['from_min'].touched && stack.controls['to_min'].touched) && (stack.controls['from_min'].value > stack.controls['to_min'].value))"
                      message="From minutes can't be higher than to minutes."></control-message>
                  </div>

                  <div class="form-group col-sm-2 col-xs-12">
                    <label for="charge">Charge</label>
                    <input type="number" class="form-control" formControlName="rate">
                    <control-message
                      *ngIf="stack.controls['rate'].hasError('required') && (stack.controls['rate'].touched)"
                      message="Charges is required."></control-message>
                    <control-message
                      *ngIf="stack.controls['rate'].hasError('pattern') && (stack.controls['rate'].touched)"
                      message="Charges must be a number."></control-message>
                  </div>

                  <div class="form-group col-sm-2 col-xs-12">
                    <label for="label_en">Label En</label>
                    <input type="text" class="form-control" formControlName="label_en">
                  </div>

                  <div class="form-group col-sm-2 col-xs-12">
                    <label for="label_ar">Label Ar</label>
                    <input type="text" class="form-control" formControlName="label_ar">
                  </div>


                  <div class="form-group col-sm-2 col-xs-12" style="margin-top:1.8em">
                    <button type="button"
                      [disabled]="!stack.valid || (stack.controls['from_min'].value > stack.controls['to_min'].value)"
                      (click)="saveFormGroup('stack')" class="btn btn-primary">Add</button>
                  </div>
                </div>

                <div class="col-sm-12 col-xs-12" [formGroup]="stack">
                  <control-message
                    *ngIf="form.controls['charge_stack'].hasError('required') && (isSubmitted || form.controls['charge_stack'].touched)"
                    message="At least one charging stack is required."></control-message>
                </div>
                <div>
                  <table class="table table-bordered table-striped">
                    <tr>
                      <th>From Minutes</th>
                      <th>To Minutes</th>
                      <th>Charges</th>
                      <th>Label En</th>
                      <th>Label Ar</th>
                      <th>Actions</th>
                    </tr>
                    <tr *ngFor="let item of form.controls['charge_stack']['controls']; let i = index;">
                      <td>
                        <p
                          *ngIf="view_charge_stack?.controls['id'].value!=item.controls['id'].value || view_charge_stack?.controls['id'].value==null">
                          {{item.controls['from_min'].value}}</p>
                        <input
                          *ngIf="view_charge_stack?.controls['id'].value==item.controls['id'].value && view_charge_stack?.controls['id'].value!=null"
                          type="text" class="form-control" [(ngModel)]="selected_from_minutes"
                          [ngModelOptions]="{standalone: true}">
                      </td>
                      <td>
                        <p
                          *ngIf="view_charge_stack?.controls['id'].value!=item.controls['id'].value || view_charge_stack?.controls['id'].value==null">
                          {{item.controls['to_min'].value}}</p>
                        <input
                          *ngIf="view_charge_stack?.controls['id'].value==item.controls['id'].value && view_charge_stack?.controls['id'].value!=null"
                          type="text" class="form-control" [(ngModel)]="selected_to_minutes"
                          [ngModelOptions]="{standalone: true}">
                      </td>
                      <td>
                        <p
                          *ngIf="view_charge_stack?.controls['id'].value!=item.controls['id'].value || view_charge_stack?.controls['id'].value==null">
                          {{item.controls['rate'].value | number:"1.3"}} {{item.controls['currency'].value}}</p>
                        <input
                          *ngIf="view_charge_stack?.controls['id'].value==item.controls['id'].value && view_charge_stack?.controls['id'].value!=null"
                          type="text" class="form-control" [(ngModel)]="selected_rate"
                          [ngModelOptions]="{standalone: true}">
                      </td>
                      <td>
                        <p
                          *ngIf="view_charge_stack?.controls['id'].value!=item.controls['id'].value || view_charge_stack?.controls['id'].value==null">
                          {{item.controls['label_en'].value}}</p>
                        <input
                          *ngIf="view_charge_stack?.controls['id'].value==item.controls['id'].value && view_charge_stack?.controls['id'].value!=null"
                          type="text" class="form-control" [(ngModel)]="selected_label_en"
                          [ngModelOptions]="{standalone: true}">
                      </td>
                      <td>
                        <p
                          *ngIf="view_charge_stack?.controls['id'].value!=item.controls['id'].value || view_charge_stack?.controls['id'].value==null">
                          {{item.controls['label_ar'].value}}</p>
                        <input
                          *ngIf="view_charge_stack?.controls['id'].value==item.controls['id'].value && view_charge_stack?.controls['id'].value!=null"
                          type="text" class="form-control" [(ngModel)]="selected_label_ar"
                          [ngModelOptions]="{standalone: true}">
                      </td>

                      <td>
                        <button type="button"
                          *ngIf="view_charge_stack?.controls['id'].value==item.controls['id'].value && view_charge_stack?.controls['id'].value!=null"
                          (click)="editFormGroup('stack')" class="btn btn-primary">Save</button>
                        <i *ngIf="view_charge_stack?.controls['id'].value!=item.controls['id'].value"
                          class="fa fa-eye fa-2x" style="color: #00c0ef; cursor: pointer;"
                          (click)="viewFormGroup(item, 'stack')" aria-hidden="true"></i>
                        <i *ngIf="view_charge_stack?.controls['id'].value!=item.controls['id'].value || view_charge_stack?.controls['id'].value==null"
                          class="fa fa-trash-o fa-2x fa-fw" style="color:red; cursor: pointer;"
                          (click)="deleteFormGroup(i, 'stack')" aria-hidden="true"></i>
                      </td>
                    </tr>
                  </table>
                </div>
              </mat-card-content>
            </mat-card>
          </div>
        </div>

        <div formArrayName="parking_gates">
          <div class="col-sm-12 col-xs-12 form-array" [formGroup]="gate">
            <mat-card>
              <h3>Gates*</h3>
              <mat-card-header>
                <mat-card-title>
                  <h3>Gates*</h3>
                </mat-card-title>
              </mat-card-header>
              <mat-card-content>
                <div class="col-sm-12 col-xs-12">
                  <div class="form-group col-sm-3 col-xs-12">
                    <label>Gate No</label>
                    <input type="text" class="form-control" formControlName="gate_no">
                    <control-message
                      *ngIf="gate.controls['gate_no'].hasError('required') && (gate.controls['gate_no'].touched)"
                      message="Gate No is required."></control-message>
                  </div>

                  <div class="form-group col-sm-3 col-xs-12">
                    <label>Gate type</label>
                    <select class="form-control" formControlName="gate_type">
                      <option value="">select a gate type</option>
                      <option value="entry">Entry</option>
                      <option value="exit">Exit</option>
                    </select>
                    <control-message
                      *ngIf="gate.controls['gate_type'].hasError('required') && (gate.controls['gate_type'].touched)"
                      message="Gate type is required."></control-message>
                  </div>

                  <div class="form-group col-sm-3 col-xs-12">
                    <label>Status</label>
                    <select class="form-control" formControlName="status">
                      <option value="">select a status</option>
                      <option value="enabled">Enabled</option>
                      <option value="disabled">Disabled</option>
                    </select>
                    <control-message
                      *ngIf="gate.controls['status'].hasError('required') && (gate.controls['status'].touched)"
                      message="Status is required."></control-message>
                  </div>
                  <div class="form-group col-sm-1 col-xs-12" style="margin-top:1.8em">
                    <button type="button" [disabled]="!gate.valid" (click)="saveFormGroup('gate')"
                      class="btn btn-primary">Add</button>
                  </div>
                </div>
                <control-message
                  *ngIf="form.controls['parking_gates'].hasError('required') && (isSubmitted || form.controls['parking_gates'].touched)"
                  message="At least one gate is required."></control-message>
                <div>
                  <table class="table table-bordered table-striped">
                    <tr>
                      <th>Gate No</th>
                      <!-- <th>Gate Area</th> -->
                      <th>Gate Type</th>
                      <th>Status</th>
                      <th>Actions</th>
                    </tr>
                    <tr *ngFor="let item of form.controls['parking_gates']['controls']; let i = index;">
                      <td>
                        <p
                          *ngIf="view_gate?.controls['id'].value!=item.controls['id'].value || view_gate?.controls['id'].value==null">
                          {{item.controls['gate_no'].value}}</p>
                        <input
                          *ngIf="view_gate?.controls['id'].value==item.controls['id'].value && view_gate?.controls['id'].value!=null"
                          type="text" class="form-control" [(ngModel)]="selected_gate"
                          [ngModelOptions]="{standalone: true}">
                      </td>
                      <td>
                        <p
                          *ngIf="view_gate?.controls['id'].value!=item.controls['id'].value || view_gate?.controls['id'].value==null">
                          {{item.controls['gate_type'].value}}</p>
                        <select
                          *ngIf="view_gate?.controls['id'].value==item.controls['id'].value && view_gate?.controls['id'].value!=null"
                          class="form-control" [(ngModel)]="selected_gate_type" [ngModelOptions]="{standalone: true}">
                          <option value="entry">Entry</option>
                          <option value="exit">Exit</option>
                        </select>
                        <!-- <input *ngIf="view_gate?.controls['id'].value==item.controls['id'].value" type="text" class="form-control" [(ngModel)]="selected_gate" [ngModelOptions]="{standalone: true}"> -->
                      </td>
                      <td>
                        <p
                          *ngIf="view_gate?.controls['id'].value!=item.controls['id'].value || view_gate?.controls['id'].value==null">
                          {{item.controls['status'].value}}</p>
                        <select
                          *ngIf="view_gate?.controls['id'].value==item.controls['id'].value && view_gate?.controls['id'].value!=null"
                          class="form-control" [(ngModel)]="selected_gate_status" [ngModelOptions]="{standalone: true}">
                          <option value="enabled">Enabled</option>
                          <option value="disabled">Disabled</option>
                        </select>
                        <!-- <input *ngIf="view_gate?.controls['id'].value==item.controls['id'].value" type="text" class="form-control" [(ngModel)]="selected_gate" [ngModelOptions]="{standalone: true}"> -->
                      </td>
                      <td>
                        <button type="button"
                          *ngIf="view_gate?.controls['id'].value==item.controls['id'].value && view_gate?.controls['id'].value!=null"
                          (click)="editFormGroup('gate')" class="btn btn-primary">Save</button>
                        <i *ngIf="view_gate?.controls['id'].value!=item.controls['id'].value" class="fa fa-eye fa-2x"
                          style="color: #00c0ef; cursor: pointer;" (click)="viewFormGroup(item, 'gate')"
                          aria-hidden="true"></i>
                        <i *ngIf="view_gate?.controls['id'].value!=item.controls['id'].value || view_gate?.controls['id'].value==null"
                          class="fa fa-trash-o fa-2x fa-fw" style="color:red; cursor: pointer;"
                          (click)="deleteFormGroup(i, 'gate')" aria-hidden="true"></i>
                      </td>
                    </tr>
                  </table>
                </div>

              </mat-card-content>
            </mat-card>
          </div>
        </div>

        <!-- autopay machines -->
        <div formArrayName="autopay_machines">
          <div class="col-sm-12 col-xs-12 form-array" [formGroup]="autopay">
            <mat-card>
              <h3>AutoPay Machines*</h3>
              <mat-card-header>
                <mat-card-title>
                  <h3>AutoPay Machines*</h3>
                </mat-card-title>
              </mat-card-header>
              <mat-card-content>
                <div class="col-sm-12 col-xs-12">
                  <div class="form-group col-sm-3 col-xs-12">
                    <label>Machine ID</label>
                    <input type="text" class="form-control" formControlName="machine_id">
                    <control-message
                      *ngIf="autopay.controls['machine_id'].hasError('required') && (autopay.controls['machine_id'].touched)"
                      message="Machine ID is required."></control-message>
                  </div>

                  <div class="form-group col-sm-3 col-xs-12">
                    <label>Status</label>
                    <select class="form-control" formControlName="machine_status">
                      <option value="">select a status</option>
                      <option value="enabled">Enabled</option>
                      <option value="disabled">Disabled</option>
                    </select>
                    <control-message
                      *ngIf="autopay.controls['machine_status'].hasError('required') && (autopay.controls['machine_status'].touched)"
                      message="Status is required."></control-message>
                  </div>


                  <div class="form-group col-sm-1 col-xs-12" style="margin-top:1.8em">
                    <button type="button" [disabled]="!autopay.valid" (click)="saveFormGroup('autopay')"
                      class="btn btn-primary">Add</button>
                  </div>
                </div>

                <control-message
                  *ngIf="form.controls['autopay_machines'].hasError('required') && (isSubmitted || form.controls['autopay_machines'].touched)"
                  message="At least one Autopay Machine is required.">
                </control-message>


                <div>
                  <table class="table table-bordered table-striped">
                    <tr>
                      <th>Autopay Machine ID</th>
                      <th>Status</th>
                      <!-- <th>Actions</th> -->
                    </tr>
                    <tr *ngFor="let item of form.controls['autopay_machines']['controls']; let i = index;">
                      <td>
                        <p
                          *ngIf="view_autopay?.controls['id'].value!=item.controls['id'].value || view_autopay?.controls['id'].value==null">
                          {{item.controls['machine_id'].value}}</p>
                        <input
                          *ngIf="view_autopay?.controls['id'].value==item.controls['id'].value && view_autopay?.controls['id'].value!=null"
                          type="text" class="form-control" [(ngModel)]="selected_machine_id"
                          [ngModelOptions]="{standalone: true}">
                      </td>

                      <td>
                        <p
                          *ngIf="view_autopay?.controls['id'].value!=item.controls['id'].value || view_autopay?.controls['id'].value==null">
                          {{item.controls['machine_status'].value}}</p>
                        <select
                          *ngIf="view_autopay?.controls['id'].value==item.controls['id'].value && view_autopay?.controls['id'].value!=null"
                          class="form-control" [(ngModel)]="selected_autopay_status"
                          [ngModelOptions]="{standalone: true}">
                          <option value="enabled">Enabled</option>
                          <option value="disabled">Disabled</option>
                        </select>
                      </td>
                      <td>

                        <button type="button"
                          *ngIf="view_autopay?.controls['id'].value==item.controls['id'].value && view_autopay?.controls['id'].value!=null"
                          (click)="editFormGroup('autopay')" class="btn btn-primary">Save</button>
                        <i *ngIf="view_autopay?.controls['id'].value!=item.controls['id'].value" class="fa fa-eye fa-2x"
                          style="color: #00c0ef; cursor: pointer;" (click)="viewFormGroup(item, 'autopay')"
                          aria-hidden="true"></i>
                        <i *ngIf="view_autopay?.controls['id'].value!=item.controls['id'].value || view_autopay?.controls['id'].value==null"
                          class="fa fa-trash-o fa-2x fa-fw" style="color:red; cursor: pointer;"
                          (click)="deleteFormGroup(i, 'autopay')" aria-hidden="true"></i>
                      </td>
                    </tr>
                  </table>
                </div>

              </mat-card-content>
            </mat-card>
          </div>
        </div>






        <div formArrayName="camera_groups">
          <div class="col-sm-12 col-xs-12 form-array" [formGroup]="camera_groups">
            <mat-card>
              <h3>Camera Group*</h3>
              <mat-card-header>
                <mat-card-title>
                  <h3>Camera Groups</h3>
                </mat-card-title>
              </mat-card-header>
              <mat-card-content>
                <div class="col-sm-12 col-xs-12">
                  <div class="form-group col-sm-3 col-xs-12">
                    <label>Camera Group Id</label>
                    <input type="text" class="form-control" formControlName="camera_group_id">
                    <control-message
                      *ngIf="camera_groups.controls['camera_group_id'].hasError('required') && (camera_groups.controls['camera_group_id'].touched)"
                      message="Camera Group Id is required."></control-message>
                  </div>

                  <div class="form-group col-sm-3 col-xs-12">
                    <label>Camera Group Name</label>
                    <input type="text" class="form-control" formControlName="name">
                    <control-message
                      *ngIf="camera_groups.controls['name'].hasError('required') && (camera_groups.controls['name'].touched)"
                      message="Camera Group Name is required."></control-message>
                  </div>


                  <div class="form-group col-sm-3 col-xs-12">
                    <label>Parking Gates</label>
                    <select class="form-control" multiple formControlName="parking_gates">
                      <option *ngFor="let item of form.controls['parking_gates']['controls']"
                        value="{{item.controls['gate_no'].value}}">{{item.controls['gate_no'].value}}</option>

                    </select>
                    <control-message
                      *ngIf="camera_groups.controls['parking_gates'].hasError('required') && (camera_groups.controls['parking_gates'].touched)"
                      message="Parking Gate is required."></control-message>
                  </div>

                  <div class="form-group col-sm-3 col-xs-12">
                    <label>Status</label>
                    <select class="form-control" formControlName="status">
                      <option value="">select a status</option>
                      <option value="enabled">Enabled</option>
                      <option value="disabled">Disabled</option>
                    </select>
                    <control-message
                      *ngIf="camera_groups.controls['status'].hasError('required') && (camera_groups.controls['status'].touched)"
                      message="Status is required."></control-message>
                  </div>
                  <div class="form-group col-sm-1 col-xs-12" style="margin-top:1.8em">
                    <button type="button" [disabled]="!camera_groups.valid" (click)="saveFormGroup('camera_groups')"
                      class="btn btn-primary">Add</button>
                  </div>
                </div>
                <!-- <control-message
                  *ngIf="form.controls['camera_groups'].hasError('required') && (isSubmitted || form.controls['camera_groups'].touched)"
                  message="At least one camera group is required."></control-message> -->
                <div>
                  <table class="table table-bordered table-striped">
                    <tr>
                      <th>Camera Group Id</th>
                      <th>Camera Group Name</th>
                      <th>Parking Gates</th>
                      <th>Status</th>
                      <th>Actions</th>
                    </tr>
                    <tr *ngFor="let item of form.controls['camera_groups']['controls']; let i = index;">
                      <td>
                        <p
                          *ngIf="view_camera_groups?.controls['id'].value!=item.controls['id'].value || view_camera_groups?.controls['id'].value==null">
                          {{item.controls['camera_group_id'].value}}</p>
                        <input
                          *ngIf="view_camera_groups?.controls['id'].value==item.controls['id'].value && view_camera_groups?.controls['id'].value!=null"
                          type="text" class="form-control" [(ngModel)]="selected_camera_group_id"
                          [ngModelOptions]="{standalone: true}">
                      </td>
                      <td>
                        <p
                          *ngIf="view_camera_groups?.controls['id'].value!=item.controls['id'].value || view_camera_groups?.controls['id'].value==null">
                          {{item.controls['name'].value}}</p>
                        <input
                          *ngIf="view_camera_groups?.controls['id'].value==item.controls['id'].value && view_camera_groups?.controls['id'].value!=null"
                          type="text" class="form-control" [(ngModel)]="selected_name"
                          [ngModelOptions]="{standalone: true}">
                      </td>
                      <td>
                        <p
                          *ngIf="view_camera_groups?.controls['id'].value!=item.controls['id'].value || view_camera_groups?.controls['id'].value==null">
                          {{item.controls['parking_gates'].value}}</p>

                        <select
                          *ngIf="view_camera_groups?.controls['id'].value==item.controls['id'].value && view_camera_groups?.controls['id'].value!=null"
                          class="form-control" [(ngModel)]="selected_parking_gates"
                          [ngModelOptions]="{standalone: true}" multiple>
                          <option *ngFor="let item of form.controls['parking_gates']['controls']"
                            value="{{item.controls['gate_no'].value}}">{{item.controls['gate_no'].value}}</option>

                        </select>
                        <!-- <input *ngIf="view_camera_groups?.controls['id'].value==item.controls['id'].value" type="text" class="form-control" [(ngModel)]="selected_parking_gates" [ngModelOptions]="{standalone: true}"> -->
                      </td>
                      <td>
                        <p
                          *ngIf="view_camera_groups?.controls['id'].value!=item.controls['id'].value || view_camera_groups?.controls['id'].value==null">
                          {{item.controls['status'].value}}</p>

                        <select
                          *ngIf="view_camera_groups?.controls['id'].value==item.controls['id'].value && view_camera_groups?.controls['id'].value!=null"
                          class="form-control" [(ngModel)]="selected_status" [ngModelOptions]="{standalone: true}">
                          <option value="enabled">Enabled</option>
                          <option value="disabled">Disabled</option>
                        </select>
                        <!-- <input *ngIf="view_camera_groups?.controls['id'].value==item.controls['id'].value" type="text" class="form-control" [(ngModel)]="selected_status" [ngModelOptions]="{standalone: true}"></td> -->
                      <td>
                        <button type="button"
                          *ngIf="view_camera_groups?.controls['id'].value==item.controls['id'].value && view_camera_groups?.controls['id'].value!=null"
                          (click)="editFormGroup('camera_groups')" class="btn btn-primary">Save</button>
                        <i *ngIf="view_camera_groups?.controls['id'].value!=item.controls['id'].value"
                          class="fa fa-eye fa-2x" style="color: #00c0ef; cursor: pointer;"
                          (click)="viewFormGroup(item, 'camera_groups')" aria-hidden="true"></i>
                        <i *ngIf="view_camera_groups?.controls['id'].value!=item.controls['id'].value || view_camera_groups?.controls['id'].value==null"
                          class="fa fa-trash-o fa-2x fa-fw" style="color:red; cursor: pointer;"
                          (click)="deleteFormGroup(i, 'camera_groups')" aria-hidden="true"></i>
                      </td>
                    </tr>
                  </table>
                </div>

              </mat-card-content>
            </mat-card>
          </div>
        </div>

        <div formArrayName="parking_beneficiary">
          <div class="col-sm-12 col-xs-12 form-array" [formGroup]="beneficiary">
            <mat-card>
              <mat-card-header>
                <mat-card-title>
                  <h3>Benficiaries*</h3>
                </mat-card-title>
              </mat-card-header>
              <mat-card-content>
                <div class="col-sm-12 col-xs-12">

                  <div class="form-group col-sm-3 col-xs-12">
                    <label>Beneficiary Name</label>
                    <select class="form-control" formControlName="beneficiary">
                      <option value="">select a beneficiary</option>
                      <option *ngFor="let item of beneficiaries" value="{{item.id}}">{{item.title}}</option>
                    </select>
                    <control-message
                      *ngIf="beneficiary.controls['beneficiary'].hasError('required') && (beneficiary.controls['beneficiary'].touched)"
                      message="Name is required."></control-message>
                  </div>

                  <div class="form-group col-sm-2 col-xs-12">
                    <label>Amount type</label>
                    <select class="form-control" formControlName="amount_type">
                      <option value="">select an amount type</option>
                      <option value="fees">Fees</option>
                      <option value="charges">Charges</option>
                    </select>
                    <control-message
                      *ngIf="beneficiary.controls['amount_type'].hasError('required') && (beneficiary.controls['amount_type'].touched)"
                      message="Amount type is required."></control-message>
                  </div>


                  <div class="form-group col-sm-3 col-xs-12">
                    <label>Amount Calculation</label>
                    <select class="form-control" formControlName="amount_calc">
                      <option value="">select an amount calculation</option>
                      <option value="fixed">Fixed</option>
                      <option value="percentage">Percentage</option>
                    </select>
                    <control-message
                      *ngIf="beneficiary.controls['amount_calc'].hasError('required') && (beneficiary.controls['amount_calc'].touched)"
                      message="Amount calculation is required."></control-message>
                  </div>

                  <div class="form-group col-sm-3 col-xs-12">
                    <label>Value</label>
                    <input type="number" class="form-control" formControlName="value">
                    <control-message
                      *ngIf="beneficiary.controls['value'].hasError('required') && (beneficiary.controls['value'].touched)"
                      message="Value is required."></control-message>
                  </div>

                  <div class="form-group col-sm-1 col-xs-12" style="margin-top:1.8em">
                    <button type="button" [disabled]="!beneficiary.valid" (click)="saveFormGroup('beneficiary')"
                      class="btn btn-primary">Add</button>
                  </div>
                </div>
                <control-message
                  *ngIf="form.controls['parking_beneficiary'].hasError('required') && (isSubmitted || form.controls['parking_beneficiary'].touched)"
                  message="At least one beneficiary is required."></control-message>
                <div *ngIf="beneficiaries">
                  <table class="table table-bordered table-striped">
                    <tr>
                      <th>Beneficiary</th>
                      <th>Amount Type</th>
                      <th>Amount Calculation</th>
                      <th>Value</th>
                      <th>Actions</th>
                    </tr>
                    <tr *ngFor="let item of form.controls['parking_beneficiary']['controls']; let i = index;">
                      <td>
                        <p
                          *ngIf="view_beneficiaries?.controls['id'].value!=item.controls['id'].value || view_beneficiaries?.controls['id'].value==null">
                          {{getTitle(item.controls['beneficiary'].value)}}</p>
                        <input
                          *ngIf="view_beneficiaries?.controls['id'].value==item.controls['id'].value && view_beneficiaries?.controls['id'].value!=null"
                          type="text" class="form-control" [(ngModel)]="selected_beneficiary"
                          [ngModelOptions]="{standalone: true}">
                      </td>

                      <td>
                        <p
                          *ngIf="view_beneficiaries?.controls['id'].value!=item.controls['id'].value || view_beneficiaries?.controls['id'].value==null">
                          {{item.controls['amount_type'].value}}</p>
                        <select
                          *ngIf="view_beneficiaries?.controls['id'].value==item.controls['id'].value && view_beneficiaries?.controls['id'].value!=null"
                          class="form-control" [(ngModel)]="selected_amount_type" [ngModelOptions]="{standalone: true}">
                          <option value="fees">Fees</option>
                          <option value="charges">Charges</option>
                        </select>
                        <!-- <input *ngIf="view_beneficiaries?.controls['id'].value==item.controls['id'].value" type="text" class="form-control" [(ngModel)]="selected_amount_type" [ngModelOptions]="{standalone: true}"></td> -->
                      <td>
                        <p
                          *ngIf="view_beneficiaries?.controls['id'].value!=item.controls['id'].value || view_beneficiaries?.controls['id'].value==null">
                          {{item.controls['amount_calc'].value}}</p>
                        <select
                          *ngIf="view_beneficiaries?.controls['id'].value==item.controls['id'].value && view_beneficiaries?.controls['id'].value!=null"
                          class="form-control" [(ngModel)]="selected_amount_calc" [ngModelOptions]="{standalone: true}">
                          <option value="fixed">Fixed</option>
                          <option value="percentage">Percentage</option>
                        </select>
                        <!-- <input *ngIf="view_beneficiaries?.controls['id'].value==item.controls['id'].value" type="text" class="form-control" [(ngModel)]="selected_amount_calc" [ngModelOptions]="{standalone: true}"></td> -->
                      <td *ngIf="item.controls['amount_calc'].value != 'percentage'">
                        <p
                          *ngIf="view_beneficiaries?.controls['id'].value!=item.controls['id'].value || view_beneficiaries?.controls['id'].value==null">
                          {{item.controls['value'].value |
                          number:"1.3"}} KD</p>
                        <input
                          *ngIf="view_beneficiaries?.controls['id'].value==item.controls['id'].value && view_beneficiaries?.controls['id'].value!=null"
                          type="text" class="form-control" [(ngModel)]="selected_value"
                          [ngModelOptions]="{standalone: true}">
                      </td>
                      <td *ngIf="item.controls['amount_calc'].value == 'percentage'">
                        <p
                          *ngIf="view_beneficiaries?.controls['id'].value!=item.controls['id'].value || view_beneficiaries?.controls['id'].value==null">
                          {{item.controls['value'].value}}%</p>
                        <input
                          *ngIf="view_beneficiaries?.controls['id'].value==item.controls['id'].value && view_beneficiaries?.controls['id'].value!=null"
                          type="text" class="form-control" [(ngModel)]="selected_value"
                          [ngModelOptions]="{standalone: true}">
                      </td>
                      <td>
                        <button type="button"
                          *ngIf="view_beneficiaries?.controls['id'].value==item.controls['id'].value && view_beneficiaries?.controls['id'].value!=null"
                          (click)="editFormGroup('beneficiary')" class="btn btn-primary">Save</button>
                        <i *ngIf="view_beneficiaries?.controls['id'].value!=item.controls['id'].value "
                          class="fa fa-eye fa-2x" style="color: #00c0ef; cursor: pointer;"
                          (click)="viewFormGroup(item, 'beneficiary')" aria-hidden="true"></i>
                        <i *ngIf="view_beneficiaries?.controls['id'].value!=item.controls['id'].value || view_beneficiaries?.controls['id'].value==null"
                          class="fa fa-trash-o fa-2x fa-fw" style="color:red; cursor: pointer;"
                          (click)="deleteFormGroup(i, 'beneficiary')" aria-hidden="true"></i>
                      </td>
                    </tr>
                  </table>
                </div>
              </mat-card-content>
            </mat-card>
          </div>
        </div>

        <div class="clearfix"></div>

        <div class="box-footer">
          <button type="button" class="btn btn-success pull-left" matStepperPrevious>
            Previous step
          </button>
          <button type="button" class="btn btn-success pull-right" (click)="saveParkingPlace()">Submit</button>
        </div>
      </mat-step>
    </mat-stepper>
  </div>
  <!-- /.box-body -->
</form>